import { NameDto } from '../../Common/Types'

export interface BulkWithdrawalsOverviewDto {
  id: string
  name: string
  dateCreated: string
  dateUpdated: string
  type: NameDto
  transactions: {
    creditAmount: number
    debitAmount: number
    id: string
    name: string
    referenceId: string
    state: NameDto
    type: NameDto
  }[]
}

export enum BulkWithdrawalsOverviewKey {
  reference = 'reference',
  name = 'name',
  allTransactions = 'allTransactions',
  completedTransactions = 'completedTransactions',
  declinedTransactions = 'declinedTransactions',
  failedTransactions = 'failedTransactions',
  dateCreated = 'dateCreated',
  dateUpdated = 'dateUpdated',
}
export interface BulkWithdrawalNormalizedDto {
  [BulkWithdrawalsOverviewKey.name]: string
  [BulkWithdrawalsOverviewKey.allTransactions]: number
  [BulkWithdrawalsOverviewKey.completedTransactions]: number
  [BulkWithdrawalsOverviewKey.declinedTransactions]: number
  [BulkWithdrawalsOverviewKey.failedTransactions]: number
  dateCreated: string
  dateUpdated: string
}
